const dateInputMask = function dateInputMask(elm: HTMLInputElement): void {
  elm.addEventListener('keypress', function (e): void {
    if (e.keyCode < 47 || e.keyCode > 57) {
      e.preventDefault();
    }

    const len = elm.value.length;

    // If we're at a particular place, let the user type the slash
    // i.e., 12/12/1212
    if (len !== 1) {
      if (e.keyCode == 47) {
        e.preventDefault();
      }
    }

    // If they don't add the slash, do it for them...
    if (len === 2) {
      elm.value += '/';
    }

    // If they don't add the slash, do it for them...
    if (len === 5) {
      elm.value += '/';
    }
  });
};

export default dateInputMask;

// const dateInputMask = function dateInputMask(elm: HTMLInputElement): void {
//   elm.addEventListener('keypress', function (e): void {
//     if (e.keyCode < 47 || e.keyCode > 57) {
//       e.preventDefault();
//     }

//     const len = elm.value.length;

//     // If we're at a particular place, let the user type the slash
//     // i.e., 12/12/1212
//     if (len !== 1) {
//       if (e.keyCode == 47) {
//         e.preventDefault();
//       }
//     }

//     if (len === 1) {
//       if (parseInt(elm.value) > 3) {
//         e.preventDefault();
//       }
//     }

//     // If they don't add the slash, do it for them...
//     if (len === 2) {
//       if (parseInt(elm.value) > 31) {
//         e.preventDefault();
//       } else {
//         elm.value += '/';
//       }
//     }

//     if (len === 4) {
//       const month = elm.value.slice(3);
//       if (parseInt(month) > 1) {
//         e.preventDefault();
//       }
//     }

//     // If they don't add the slash, do it for them...
//     if (len === 5) {
//       const month = elm.value.slice(3);
//       if (parseInt(month) > 12) {
//         e.preventDefault();
//       } else {
//         elm.value += '/';
//       }
//     }
//   });
// };

// export default dateInputMask;
